import React, { lazy } from 'react';
export function GabrielBio() {
  return <section className="py-12 px-4 bg-dark-100" data-id="element-111">
      <div className="max-w-[680px] mx-auto" data-id="element-112">
        <p className="text-[13px] uppercase tracking-[0.1em] text-gold text-center mb-3" data-id="element-113">
          El Creador
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-body" data-id="element-114">
          ¿Quién es el hombre detrás de este protocolo?
        </h2>

        <div className="flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-115">
          <div className="w-full md:w-1/3 flex justify-center shrink-0" data-id="element-116">
            <img src="https://cdn.magicpatterns.com/uploads/54YEKsE2AGnQCQ854v599M/Gabriel_Beltran_Profile_Pic.jpg" alt="Gabriel Beltrán" className="w-48 h-48 md:w-64 md:h-64 object-cover rounded-full ring-2 ring-gold/60 ring-offset-2 ring-offset-dark-100" loading="lazy" decoding="async" data-id="element-117" />
          </div>

          <div className="w-full md:w-2/3 space-y-[12px] text-base text-body leading-[1.5] text-center md:text-left" data-id="element-118">
            <p data-id="element-119">
              Gabriel Beltrán no llegó aquí desde una vida perfecta. Llegó desde
              el mismo lugar donde probablemente estás tú ahora.
            </p>

            <p data-id="element-120">
              Conocido como{' '}
              <span className="text-gold font-semibold" data-id="element-121">
                @theecommillionaire
              </span>
              , construyó su libertad financiera desde cero — pero no antes de
              atravesar sus propios períodos de caos mental y pérdida.
            </p>

            <p data-id="element-122">
              Lo que descubrió no estaba en ningún libro.{' '}
              <span className="text-white font-medium" data-id="element-123">
                Lo descubrió en su propio sistema nervioso.
              </span>
            </p>

            <p className="font-serif italic text-base text-sage mt-4" data-id="element-124">
              The Reset Protocol no es un producto que Gabriel creó para vender.
              Es el protocolo que creó para sobrevivir.
            </p>
          </div>
        </div>
      </div>
    </section>;
}